import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/design-system/tooltip';

export const TooltipWrapper = ({
  trigger,
  content,
  className,
  delayDuration,
  side = 'top'
}: {
  trigger: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  delayDuration?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
}) => {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>{trigger}</TooltipTrigger>
        <TooltipContent side={side} className={className}>
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
